import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/Reveal";
import { FAQS } from "@/data/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  return (
    <div className="pt-32">
      <section className="px-5 sm:px-8 pb-12">
        <div className="max-w-[1000px] mx-auto">
          <Reveal><p className="text-xs uppercase tracking-[0.3em] text-forest mb-6">FAQ</p></Reveal>
          <Reveal delay={0.1}><h1 className="font-sans font-extrabold tracking-tight text-5xl sm:text-7xl leading-[1.02]">Everything you're wondering.</h1></Reveal>
        </div>
      </section>

      <section className="px-5 sm:px-8 pb-24">
        <div className="max-w-[1000px] mx-auto">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <Reveal key={f.q} delay={i * 0.04}>
                <AccordionItem value={`item-${i}`} className="border-b border-clubborder">
                  <AccordionTrigger className="text-left font-serif text-2xl sm:text-3xl py-6 hover:no-underline hover:text-forest" data-testid={`faq-trigger-${i}`}>
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-ink/60 text-base leading-relaxed pb-6 max-w-3xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              </Reveal>
            ))}
          </Accordion>

          <Reveal>
            <div className="mt-16 rounded-2xl bg-forest text-cream p-10 text-center">
              <p className="font-serif text-3xl sm:text-4xl mb-6">Still have a question?</p>
              <Link to="/book" className="inline-block rounded-full bg-cream text-forest px-8 py-3.5 text-sm font-medium hover:bg-sand transition-colors">Ask on the booking form</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
